// extracted by mini-css-extract-plugin
export default {"container":"IM-z","topReviewHeading":"JM-z","criticalReview":"KM-z","favorableReview":"LM-z","vsSeparator":"MM-z"};